import { defineComponent as _defineComponent } from 'vue'
export interface Props {
  /**
   * Title of the nav item. Will also be used as the `tooltip` if none is
   * specified.
   */
  title: string;
  /**
   * FontAwesome icon to display.
   */
  icon: IconDefinition;
  /**
   * Text to be displayed when moused over.
   */
  tooltip?: string;
  /**
   * If specified, will display a badge to the bottom-right of the nav item
   * with the given quantity.
   */
  badge?: number | null;
}


import { ref, computed } from 'vue';

import { useStore } from '@store';
import { isNumber } from '@tools/type-guards';

import type { IconDefinition } from '@icons/core';

const __default__ = { name: 'NavItemIcon' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    title: null,
    icon: null,
    tooltip: { default: '' },
    badge: { default: null }
  },
  emits: ['click'],
  setup(__props: any, { emit }) {

const props = __props as { title: string, icon: IconDefinition, tooltip: string, badge: number | null };

/**
 * `NavItemIcon` component properties.
 */


const tooltip = computed(() => props.tooltip || props.title);



const store = useStore();

const el = ref<HTMLElement | null>(null);
const wasClicked = ref(false);

const classList = computed(() => {
  const items: string[] = [];

  if (isMobile.value) {
    items.push('nav-item-icon-mobile');
  } else {
    items.push('nav-item', 'nav-item-icon');
  }

  return items;
});

const isMobile = computed(() => store.state.displayMode === 'mobile');
const disableTooltip = computed(() => wasClicked.value || isMobile.value);

function onClick() {
  wasClicked.value = true;

  emit('click');
}

function onMouseLeave() {
  wasClicked.value = false;
}

return { __sfc: true,props, tooltip, emit, store, el, wasClicked, classList, isMobile, disableTooltip, onClick, onMouseLeave, isNumber }
}

})